





























































































































import { Component, Vue } from 'vue-property-decorator';
import ExportIcon from 'mdi-vue/FileExportOutline';
import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import AddIcon from 'mdi-vue/Plus';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    AddIcon,
    Checkbox,
    Loader,
    Button,
    ExportIcon,
    SearchField,
    SearchRow,
    Select,
    Modal,
    FormInput,

  },
})
export default class PaymentChannel extends Vue {
  close() {
    this.$emit('modal', false);
  }
}
